/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/QuizMeDifficultySelector.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { DIFFICULTY_CONFIG, DIFFICULTY_LEVELS } from '../interactiveEducationConstants.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/QuizMeDifficultySelector.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const QuizMeDifficultySelector = ({
  onDifficultyChange,
  selectedDifficulty
}) => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  children: [/*#__PURE__*/_jsx(Text, {
    as: "h2",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.interactiveEducation.quiz.quizMe"
    })
  }), /*#__PURE__*/_jsx(Text, {
    as: "h3",
    marginBlock: "800",
    marginInlineEnd: "700",
    children: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.quiz.difficulty.selectLevel"
      })
    })
  }), DIFFICULTY_LEVELS.map(level => /*#__PURE__*/_jsx(SelectableButton, {
    block: true,
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: DIFFICULTY_CONFIG[level].description
    }),
    marginBlockEnd: "400",
    onClick: () => onDifficultyChange(level),
    selected: selectedDifficulty === level,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: DIFFICULTY_CONFIG[level].title
    }),
    type: "radio"
  }, level))]
});